import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

import { AdditionalInformationWidgetConfigurationHttpService } from
  '@feature/_app_modules/additional-information/services/additional-information-widget-configuration.http.service';
import { AdditionalInformationWidgetAdminHandler } from
  '@feature/_app_modules/additional-information/services/additional-information-widget-admin-handler';
import { AdditionalInformationAdminFormComponent } from './components/additional-information-admin-form/additional-information-admin-form.component';


@NgModule({
  declarations: [
    AdditionalInformationAdminFormComponent,
  ],
  exports: [
    AdditionalInformationAdminFormComponent,
    ],
  imports: [
    CommonModule,
    TableModule,
    CheckboxModule,
    FormsModule
    ],
    providers: [
      AdditionalInformationWidgetConfigurationHttpService,
      AdditionalInformationWidgetAdminHandler
  ]
})
export class AdditionalInformationAdminModule { }
